const CategoryName = ({ category }) => {
  if (!category) return ''
  const sex =
    category.areMalesAllowed && category.areFemalesAllowed
      ? 'Смешанный'
      : (category.areMalesAllowed && 'Мужчины') ||
        (category.areFemalesAllowed && 'Женщины')
  const age = category.birthYear
    ? `${category.birthYear} год рождения/`
    : `${category.minAge}-${category.maxAge}лет`
  const weightRange = (weight) => {
    if (weight > 53 && weight < 57) {
      return 'Наилегчайший'
    } else if (weight < 61) {
      return 'Легчайший'
    } else if (weight < 66) {
      return 'Полулёгкий'
    } else if (weight < 70) {
      return 'Лёгкий'
    } else if (weight < 77) {
      return 'Полусредний'
    } else if (weight < 84) {
      return 'Средний'
    } else if (weight < 93) {
      return 'Полутяжёлый'
    } else if (weight >= 93) {
      return 'Тяжёлый'
    } else return 'Невесомый'
  }
  const weight = category?.weight
    ? `/${category.weight.minWeight} до ${
        category.weight.maxWeight
      } кг (${weightRange(
        (category.weight.maxWeight + category.weight.minWeight) / 2
      )})`
    : ''
  return `${category.name}/${sex}/${category.rank.sportsmanRank}/${age}${weight}`
}

export default CategoryName
